const steps = [
  { step: "01", title: "Research", desc: "We analyze your market, competitors, and audience." },
  { step: "02", title: "Strategy", desc: "We build a customized ad strategy tailored for your goals." },
  { step: "03", title: "Launch", desc: "We launch optimized campaigns across Facebook and Google." },
  { step: "04", title: "Scale", desc: "We continuously optimize and scale profitable campaigns." },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 sm:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-16">
          <div className="text-xs font-mono tracking-widest text-[#FF5722] uppercase mb-4">
            // Workflow
          </div>
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight text-white">
            Our Proven <span className="gradient-text">Growth Process</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 relative">
          {/* Connecting line */}
          <div className="hidden lg:block absolute top-12 left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-transparent via-[#FF5722]/30 to-transparent" />

          {steps.map((s, i) => (
            <div
              key={i}
              data-testid={`process-step-${i}`}
              className="relative rounded-2xl bg-[#0c0c0c] border border-white/[0.06] p-7 hover:border-[#FF5722]/40 transition-all duration-300 group overflow-hidden"
            >
              <div className="absolute -top-4 -right-4 text-7xl font-bold text-white/[0.04] font-mono tracking-tighter pointer-events-none">
                {s.step}
              </div>

              <div className="relative">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#FF5722] text-black font-bold font-mono text-base shadow-[0_0_20px_-5px_rgba(255,87,34,0.5)]">
                  {s.step}
                </div>
                <h3 className="mt-6 text-xl font-semibold text-white tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-zinc-400 leading-relaxed">
                  {s.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
